import React from "react";
import MissionImg from "../../assets/mission.jpeg";

const Mission = () => {
	return (
		<section className=" py-14 md:py-24 bg-skyBlue relative overflow-hidden">
			{/* <div className="rounded-tl-[40px] rounded-bl-[40px] absolute left-[55%] bottom-0 top-0 w-[50vw] bg-pink-50 hidden lg:block"></div> */}
			<div className="max-w-7xl px-4 mx-auto relative">
				<div className="flex flex-col md:flex-row gap-6 md:gap-12 items-center justify-between">
					<div className="w-full md:w-1/2 xl:pr-12 text-center lg:text-start my-12">
						<h2 className="text-3xl font-bold leading-tight md:text-[40px] mb-4 uppercase">
							Our Mission
						</h2>
						<p className="text-lg md:text-[18px] leading-normal opacity-80">
                        To empower people and organisation through strategic planning and innovative solutions, to drive sustainable growth and success
						</p>
						<div className="mt-12">
							
						</div>
					</div>
					<div className="w-full md:w-1/2">
						<img
							src={MissionImg}
							alt=""
							className="mx-auto rounded-2xl h-[480px]"
						/>
					</div>
				</div>
			</div>
		</section>
	);
};


export default Mission;